import React, { useEffect, useState, useRef } from 'react'
import { getBranches, deleteDesignation, upsertSubDesignation, deleteSubDesignation, createBranch, deleteBranch, addCostCenter, updateCostCenter, deleteCostCenter } from '../../utils/urls'
import axios from '../../utils/axios';
import { InputText } from 'primereact/inputtext';
import FlexComponent from '../FlexComponent';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useSelector } from 'react-redux';
import { confirmDialog } from '../../shared/ConfirmModal';
import { Divider } from 'primereact/divider';
import AppModal from '../../shared/AppModal';
import { FileUpload } from 'primereact/fileupload';

function Branches({ toast }) {
    const [branchData, setBranchData] = useState({
        name: '',
        nmls_id: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        image: null,
        imagePreview: null
    });
    const [editBranchData, setEditBranchData] = useState({
        name: '',
        nmls_id: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        image: null,
        imagePreview: null
    });
    const userId = useSelector(state => state.user.userId);
    const fileUploadRef = useRef(null);
    const editFileUploadRef = useRef(null);

    const [isAddBranch, setIsAddBranch] = useState(false);
    const [branchList, setBranchList] = useState([]);
    const [isBranchEdit, setIsBranchEdit] = useState(false);
    const [editBranchId, setEditBranchId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMounted, setIsMounted] = useState(false);

    // States for Cost Center
    const [showAddCostCenterInput, setShowAddCostCenterInput] = useState(null);
    const [costCenterTitle, setCostCenterTitle] = useState('');
    const [editCostCenterId, setEditCostCenterId] = useState(null);
    const [editCostCenterTitle, setEditCostCenterTitle] = useState('');

    const handleAddBranch = () => {
        setIsMounted(true);
        setIsAddBranch(false);
        const formData = new FormData();
        Object.keys(branchData).forEach(key => {
            if (branchData[key] && key !== 'image' && key !== 'imagePreview') {
                formData.append(key, branchData[key]);
            }
        });
        if (branchData.image) {
            formData.append('image', branchData.image);
        }

        axios.post(createBranch, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setBranchData({
                        name: '',
                        nmls_id: '',
                        address: '',
                        city: '',
                        state: '',
                        zip: '',
                        image: null,
                        imagePreview: null
                    });
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Branch added successfully', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    const handleEditSubmit = () => {
        setIsMounted(true);
        const formData = new FormData();
        Object.keys(editBranchData).forEach(key => {
            if (editBranchData[key] && key !== 'image' && key !== 'imagePreview') {
                formData.append(key, editBranchData[key]);
            }
        });
        if (editBranchData.image && editBranchData.image instanceof File) {
            formData.append('image', editBranchData.image);
        }

        axios.patch(`/branches/${editBranchId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsBranchEdit(false);
                    setEditBranchId(null);
                    if (editFileUploadRef.current) {
                        editFileUploadRef.current.clear();
                    }
                    setEditBranchData({
                        name: '',
                        nmls_id: '',
                        address: '',
                        city: '',
                        state: '',
                        zip: '',
                        image: null,
                        imagePreview: null
                    });
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Branch updated successfully', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    const handleClick = () => {
        setBranchData({
            name: '',
            nmls_id: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            image: null,
            imagePreview: null
        });
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
        setIsAddBranch(!isAddBranch);
        setIsBranchEdit(false);
        setShowAddCostCenterInput(null);
        setEditCostCenterId(null);
    };

    const handleEdit = (index) => {
        setIsAddBranch(false);
        setIsBranchEdit(true);
        setEditBranchId(branchList[index].id);
        setEditBranchData({
            name: branchList[index].name,
            nmls_id: branchList[index].nmls_id,
            address: branchList[index].address,
            city: branchList[index].city,
            state: branchList[index].state,
            zip: branchList[index].zip,
            image: null,
            imagePreview: branchList[index].image
        });
        if (editFileUploadRef.current) {
            editFileUploadRef.current.clear();
        }
        setShowAddCostCenterInput(null);
        setEditCostCenterId(null);
    };

    const getAllBranches = () => {
        axios.get(getBranches, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    setBranchList(response.data);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const handleDelete = (list) => {
        setIsMounted(true);
        confirmDialog({
            message: 'Are you sure you want to delete this Branch?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                axios.delete(`${deleteBranch}${list.id}/`, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 204) {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Branch deleted successfully', life: 3000 });
                            setIsMounted(false);
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                            setIsMounted(false);
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        setIsMounted(false);
                    });
            },
            reject: () => {
                console.log("Deletion cancelled");
            }
        });
    };

    const handleAddCostCenter = (branchId) => {
        setIsMounted(true);
        const data = {
            name: costCenterTitle
        };
        axios.post(`${addCostCenter}${branchId}/costcenters/`, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setCostCenterTitle('');
                    setShowAddCostCenterInput(null);
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Cost center added successfully', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add cost center', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong adding cost center', life: 3000 });
            });
    };

    const handleEditCostCenter = (branchId, costCenterId, currentTitle) => {
        setEditCostCenterId(costCenterId);
        setEditCostCenterTitle(currentTitle);
        setShowAddCostCenterInput(null);
    };

    const handleUpdateCostCenter = (branchId, costCenterId) => {
        setIsMounted(true);
        const data = {
            name: editCostCenterTitle
        };
        axios.patch(`${updateCostCenter}${costCenterId}/`, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setEditCostCenterId(null);
                    setEditCostCenterTitle('');
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Cost center updated successfully', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update cost center', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong updating cost center', life: 3000 });
            });
    };

    const handleDeleteCostCenter = (branchId, costCenterId) => {
        setIsMounted(true);
        confirmDialog({
            message: 'Are you sure you want to delete this Cost Center?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                axios.delete(`${deleteCostCenter}${costCenterId}/`, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 204) {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Cost center deleted successfully', life: 3000 });
                            setIsMounted(false);
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                            setIsMounted(false);
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        setIsMounted(false);
                    });
            },
            reject: () => {
                console.log("Cost center deletion cancelled");
            }
        });
    };

    const onUpload = (event) => {
        const file = event.files[0];
        setBranchData({ 
            ...branchData, 
            image: file, 
            imagePreview: URL.createObjectURL(file) 
        });
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };

    const onEditUpload = (event) => {
        const file = event.files[0];
        setEditBranchData({ 
            ...editBranchData, 
            image: file, 
            imagePreview: URL.createObjectURL(file) 
        });
        if (editFileUploadRef.current) {
            editFileUploadRef.current.clear();
        }
    };

    useEffect(() => {
        getAllBranches();
    }, [isMounted]);

    return (
        <div>
            <AppModal
                header="Edit Branch"
                visible={isBranchEdit}
                panelStyle={{ width: '50vw' }}
                onHide={() => {
                    setIsBranchEdit(false);
                    setEditBranchId(null);
                    if (editFileUploadRef.current) {
                        editFileUploadRef.current.clear();
                    }
                    setEditBranchData({
                        name: '',
                        nmls_id: '',
                        address: '',
                        city: '',
                        state: '',
                        zip: '',
                        image: null,
                        imagePreview: null
                    });
                }}
            >
                <FlexComponent flexDirection="column" gap='.5rem' alignItems='center'>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="name" style={{ fontWeight: 'bold' }}>Name *</label>
                        <InputText size="small" style={{ width: '100%' }} id="name" value={editBranchData.name}
                            onChange={(e) => setEditBranchData({ ...editBranchData, name: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="nmls_id" style={{ fontWeight: 'bold' }}>NMLS ID</label>
                        <InputText size="small" style={{ width: '100%' }} id="nmls_id" value={editBranchData.nmls_id}
                            onChange={(e) => setEditBranchData({ ...editBranchData, nmls_id: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="address" style={{ fontWeight: 'bold' }}>Address</label>
                        <InputText size="small" style={{ width: '100%' }} id="address" value={editBranchData.address}
                            onChange={(e) => setEditBranchData({ ...editBranchData, address: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="city" style={{ fontWeight: 'bold' }}>City</label>
                        <InputText size="small" style={{ width: '100%' }} id="city" value={editBranchData.city}
                            onChange={(e) => setEditBranchData({ ...editBranchData, city: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="state" style={{ fontWeight: 'bold' }}>State</label>
                        <InputText size="small" style={{ width: '100%' }} id="state" value={editBranchData.state}
                            onChange={(e) => setEditBranchData({ ...editBranchData, state: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="zip" style={{ fontWeight: 'bold' }}>Zip</label>
                        <InputText size="small" style={{ width: '100%' }} id="zip" value={editBranchData.zip}
                            onChange={(e) => setEditBranchData({ ...editBranchData, zip: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="image" style={{ fontWeight: 'bold' }}>Image</label>
                        {editBranchData.imagePreview && (
                            <div style={{ margin: '1rem 0' }}>
                                <img 
                                    src={editBranchData.imagePreview} 
                                    alt="Branch preview" 
                                    style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }} 
                                />
                            </div>
                        )}
                        <FileUpload 
                            ref={editFileUploadRef}
                            name="image" 
                            accept="image/*" 
                            maxFileSize={1000000} 
                            onSelect={onEditUpload}
                            customUpload
                            uploadLabel="Upload"
                            chooseLabel="Select Image"
                            cancelLabel="Clear"
                            showUploadButton={true}
                            showCancelButton={false}
                            mode="basic"
                        />
                    </div>
                    <FlexComponent justifyContent="center" gap="1rem">
                        <Button type='button' onClick={handleEditSubmit} disabled={!editBranchData.name.trim()}>Update</Button>
                        <Button 
                            style={{ background: "white", color: "black" }} 
                            type='button' 
                            onClick={() => {
                                setIsBranchEdit(false);
                                setEditBranchId(null);
                                if (editFileUploadRef.current) {
                                    editFileUploadRef.current.clear();
                                }
                                setEditBranchData({
                                    name: '',
                                    nmls_id: '',
                                    address: '',
                                    city: '',
                                    state: '',
                                    zip: '',
                                    image: null,
                                    imagePreview: null
                                });
                            }}
                        >
                            Cancel
                        </Button>
                    </FlexComponent>
                </FlexComponent>
            </AppModal>

            {branchList?.length > 0 &&
                <div>
                    {branchList.map((list, index) => (
                        <div key={index} style={{ marginTop: ".5rem" }}>
                            <FlexComponent gap="1rem">
                                <FlexComponent justifyContent="start" style={{ height: "50px", width: "100%" }}>
                                    <p style={{ fontWeight: "bold", fontSize: "1.2rem" }}>{list.name}</p>
                                </FlexComponent>
                                <Button style={{ padding: ".5rem .6rem" }} onClick={() => handleEdit(index)} icon="pi pi-pencil" />
                                <Button style={{ padding: ".5rem .6rem" }} onClick={() => handleDelete(list)} icon="pi pi-trash" />
                            </FlexComponent>

                            <FlexComponent alignItems="center" justifyContent="start" gap="1rem">
                                <div htmlFor="costCenterTitle" style={{ fontWeight: 'bold' }}>Cost Centers</div>
                                <Button
                                    style={{ padding: ".5rem" }}
                                    onClick={() => {
                                        setShowAddCostCenterInput(showAddCostCenterInput === list.id ? null : list.id);
                                        setCostCenterTitle('');
                                        setIsAddBranch(false);
                                        setIsBranchEdit(false);
                                        setEditCostCenterId(null);
                                    }}
                                    icon="pi pi-plus"
                                />
                            </FlexComponent>

                            {showAddCostCenterInput === list.id && (
                                <FlexComponent style={{ marginTop: ".5rem", border: "1px dashed grey", padding: "1rem", borderRadius: "10px" }} className='inputFlexContainer' flexDirection="column" gap='.5rem' alignItems='center'>
                                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                                        <InputText size="small" style={{ width: '100%' }} id="costCenterTitle" value={costCenterTitle}
                                            onChange={(e) => setCostCenterTitle(e.target.value)}
                                        />
                                    </div>
                                    <FlexComponent justifyContent="center" gap="1rem">
                                        <Button type='button' onClick={() => handleAddCostCenter(list.id)} label='Add Cost Center' disabled={!costCenterTitle.trim()} />
                                        <Button style={{ background: "white", color: "black" }} type='button' label='Cancel' onClick={() => setShowAddCostCenterInput(null)} />
                                    </FlexComponent>
                                </FlexComponent>
                            )}

                            {list.cost_centers && list.cost_centers.length > 0 && (
                                <div style={{ marginLeft: "2rem" }}>
                                    <ul>
                                        {list.cost_centers.map((sub, subIndex) => (
                                            <li key={subIndex} style={{ marginTop: ".5rem" }}>
                                                {editCostCenterId === sub.id ? (
                                                    <FlexComponent style={{ marginTop: ".5rem", border: "1px dashed grey", padding: "1rem", borderRadius: "10px" }} className='inputFlexContainer' flexDirection="column" gap='.5rem' alignItems='center'>
                                                        <div className='inputContainerDiv' style={{ width: '100%' }}>
                                                            <InputText
                                                                size="small"
                                                                style={{ width: '100%' }}
                                                                id="editCostCenterTitle"
                                                                value={editCostCenterTitle}
                                                                onChange={(e) => setEditCostCenterTitle(e.target.value)}
                                                            />
                                                        </div>
                                                        <FlexComponent justifyContent="center" gap="1rem">
                                                            <Button
                                                                type='button'
                                                                label='Update Cost Center'
                                                                onClick={() => handleUpdateCostCenter(list.id, sub.id)}
                                                                disabled={!editCostCenterTitle.trim()}
                                                            />
                                                            <Button
                                                                style={{ background: "white", color: "black" }}
                                                                type='button'
                                                                label='Cancel'
                                                                onClick={() => setEditCostCenterId(null)}
                                                            />
                                                        </FlexComponent>
                                                    </FlexComponent>
                                                ) : (
                                                    <FlexComponent gap="1rem" alignItems="center">
                                                        <div>{sub.name}</div>
                                                        <div>
                                                            <Button
                                                                style={{ padding: ".3rem .4rem", marginRight: ".5rem" }}
                                                                icon="pi pi-pencil"
                                                                onClick={() => handleEditCostCenter(list.id, sub.id, sub.name)}
                                                            />
                                                            <Button
                                                                style={{ padding: ".3rem .4rem" }}
                                                                icon="pi pi-trash"
                                                                onClick={() => handleDeleteCostCenter(list.id, sub.id)}
                                                            />
                                                        </div>
                                                    </FlexComponent>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <Divider />
                        </div>
                    ))}
                </div>}

            {loading && <FlexComponent justifyContent="center">
                <ProgressSpinner />
            </FlexComponent>}

            <Button style={{ marginTop: ".5rem" }} onClick={handleClick}>Add Branch</Button>
            {isAddBranch && (
                <FlexComponent style={{ marginTop: "1rem", border: "1px solid grey", padding: "1rem", borderRadius: "15px" }} className='inputFlexContainer' flexDirection="column" gap='.5rem' alignItems='center'>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="name" style={{ fontWeight: 'bold' }}>Name *</label>
                        <InputText size="small" style={{ width: '100%' }} id="name" value={branchData.name}
                            onChange={(e) => setBranchData({ ...branchData, name: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="nmls_id" style={{ fontWeight: 'bold' }}>NMLS ID</label>
                        <InputText size="small" style={{ width: '100%' }} id="nmls_id" value={branchData.nmls_id}
                            onChange={(e) => setBranchData({ ...branchData, nmls_id: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="address" style={{ fontWeight: 'bold' }}>Address</label>
                        <InputText size="small" style={{ width: '100%' }} id="address" value={branchData.address}
                            onChange={(e) => setBranchData({ ...branchData, address: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="city" style={{ fontWeight: 'bold' }}>City</label>
                        <InputText size="small" style={{ width: '100%' }} id="city" value={branchData.city}
                            onChange={(e) => setBranchData({ ...branchData, city: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="state" style={{ fontWeight: 'bold' }}>State</label>
                        <InputText size="small" style={{ width: '100%' }} id="state" value={branchData.state}
                            onChange={(e) => setBranchData({ ...branchData, state: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="zip" style={{ fontWeight: 'bold' }}>Zip</label>
                        <InputText size="small" style={{ width: '100%' }} id="zip" value={branchData.zip}
                            onChange={(e) => setBranchData({ ...branchData, zip: e.target.value })}
                        />
                    </div>
                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                        <label htmlFor="image" style={{ fontWeight: 'bold' }}>Image</label>
                        {branchData.imagePreview && (
                            <div style={{ margin: '1rem 0' }}>
                                <img 
                                    src={branchData.imagePreview} 
                                    alt="Branch preview" 
                                    style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }} 
                                />
                            </div>
                        )}
                        <FileUpload 
                            ref={fileUploadRef}
                            name="image" 
                            accept="image/*" 
                            maxFileSize={1000000} 
                            onSelect={onUpload}
                            customUpload
                            uploadLabel="Upload"
                            chooseLabel="Select Image"
                            cancelLabel="Clear"
                            showUploadButton={true}
                            showCancelButton={false}
                            mode="basic"
                        />
                    </div>
                    <FlexComponent justifyContent="center" gap="1rem">
                        <Button type='button' onClick={handleAddBranch} disabled={!branchData.name.trim()}>Save</Button>
                        <Button style={{ background: "white", color: "black" }} type='button' onClick={() => setIsAddBranch(false)}>Cancel</Button>
                    </FlexComponent>
                </FlexComponent>
            )}
        </div>
    );
}

export default Branches;